import React, { useState, useEffect } from "react";
import { ref, set } from "firebase/database";
import { db } from "../services/firebase";
import { useNavigate } from "react-router-dom";
import "./StudentDetails.css";

export default function StudentDetails() {
  const [mode, setMode] = useState("school");
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    class: "",
    section: "",
    rollNo: "",
    universityRoll: "",
  });

  const navigate = useNavigate();
  const session = JSON.parse(localStorage.getItem("studentSession"));

  useEffect(() => {
    if (!session?.studentId) {
      navigate("/student-login");
    }
  }, [navigate, session]);

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const generateStudentSpecialId = (institute = "INST") => {
    const cleanInstitute = institute
      .replace(/[^A-Za-z]/g, "")
      .toUpperCase()
      .slice(0, 10) || "INST";

    const year = new Date().getFullYear();

    const now = new Date();
    const dateTime =
      now.getFullYear().toString() +
      String(now.getMonth() + 1).padStart(2, "0") +
      String(now.getDate()).padStart(2, "0") +
      "-" +
      String(now.getHours()).padStart(2, "0") +
      String(now.getMinutes()).padStart(2, "0") +
      String(now.getSeconds()).padStart(2, "0");

    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const randomPart =
      letters[Math.floor(Math.random() * 26)] +
      letters[Math.floor(Math.random() * 26)] +
      Math.floor(Math.random() * 10) +
      Math.floor(Math.random() * 10);

    return `${cleanInstitute}-${year}-${dateTime}-${randomPart}`;
  };

  const handleSubmit = async () => {
    if (!form.name || !form.phone) {
      alert("Name and Phone are required");
      return;
    }

    if (mode === "school" && (!form.class || !form.rollNo)) {
      alert("Class and Roll No required");
      return;
    }

    if (mode === "college" && !form.universityRoll) {
      alert("University Roll required");
      return;
    }

    try {
      setLoading(true);

      const specialStudentId = generateStudentSpecialId(
        session?.institute || "INST"
      );

      const studentData = {
        specialStudentId,
        loginId: session.studentId,
        testId: session.testId || "DEFAULT", // Link to test (DEFAULT or teacher's test)
        testType: session.testType,
        institute: session.institute,
        year: session.year,
        mode,
        details: form,
        startedAt: Date.now(),
        status: "in_progress", // Changed from "started" to match TestRouter
      };

      await set(
        ref(db, `studentAttempts/${specialStudentId}`),
        studentData
      );

      localStorage.setItem(
        "studentSession",
        JSON.stringify({
          ...session,
          specialStudentId,
          detailsFilled: true,
        })
      );

      navigate("/start-test");
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sd-wrapper">
      <div className="sd-card">
        <h2>📝 Student Details</h2>
        <p>Please confirm your information before starting</p>

        <div className="sd-toggle">
          <button
            className={mode === "school" ? "active" : ""}
            onClick={() => setMode("school")}
          >
            School
          </button>
          <button
            className={mode === "college" ? "active" : ""}
            onClick={() => setMode("college")}
          >
            College
          </button>
        </div>

        <input placeholder="Full Name" onChange={(e) => handleChange("name", e.target.value)} />
        <input placeholder="Email (optional)" onChange={(e) => handleChange("email", e.target.value)} />
        <input placeholder="Phone Number" onChange={(e) => handleChange("phone", e.target.value)} />

        {mode === "school" && (
          <>
            <input placeholder="Class" onChange={(e) => handleChange("class", e.target.value)} />
            <input placeholder="Section" onChange={(e) => handleChange("section", e.target.value)} />
            <input placeholder="Roll Number" onChange={(e) => handleChange("rollNo", e.target.value)} />
          </>
        )}

        {mode === "college" && (
          <input
            placeholder="University Roll Number"
            onChange={(e) => handleChange("universityRoll", e.target.value)}
          />
        )}

        <button className="sd-start-btn" onClick={handleSubmit} disabled={loading}>
          {loading ? "Starting..." : "🚀 Proceed to Test"}
        </button>
      </div>
    </div>
  );
}
